import * as React from 'react';
import ReactTextareaAutosize from 'react-autosize-textarea';
import { cn } from '@/lib/utils';

const TextareaAutosize = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <ReactTextareaAutosize
      ref={ref}
      className={cn(
        'c-textarea-autosize',
        'flex min-h-[100px] w-full rounded-md border border-solid border-primary-lightest bg-background px-3 py-2 text-base text-neutral ring-offset-background placeholder:text-neutral-light md:text-sm',
        'hover:border-neutral-light hover:bg-bright hover:text-neutral-dark',
        'focus-visible:border-neutral-dark focus-visible:text-neutral-dark focus-visible:outline-none',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'transition-colors duration-150',
        '[&[aria-invalid=true]]:border-danger',
        className
      )}
      {...props}
    />
  );
});
TextareaAutosize.displayName = 'TextareaAutosize';

export { TextareaAutosize };
